import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { generateCardNumPlaceholder } from 'store/ticketingPublic';
import { getOrderTotalPrice } from 'store/updateTicketing';
import { accessNested, displayWhen, isObject, joinClasses } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { Link } from 'components/core/link/link.js';
import PaymentLoader from 'components/shared/theaters/ticketing/gateways/paymentLoader';
import s from 'components/shared/theaters/ticketing/gateways/braintreePaymentGateway/braintreePaymentGateway.sss';
import bb from 'components/shared/theaters/ticketing/bottomBar.sss';


// TODO: use debug libs in development
// TODO: add copy for field names and button
// TODO: error handling
// TODO: dynamic placeholder date

// TODO: Localize braintree tokenization errors

// Debug libs
// const BRAINTREE_SDK_SRC = 'https://js.braintreegateway.com/web/3.33.0/js/client.js';
// const BRAINTREE_HOSTED_FIELDS_SRC = 'https://js.braintreegateway.com/web/3.33.0/js/hosted-fields.js';

const BRAINTREE_SDK_SRC = 'https://js.braintreegateway.com/web/3.50.1/js/client.min.js';
const BRAINTREE_HOSTED_FIELDS_SRC = 'https://js.braintreegateway.com/web/3.50.1/js/hosted-fields.min.js';
const BRAINTREE_THREE_D_SECURE_SRC = 'https://js.braintreegateway.com/web/3.50.1/js/three-d-secure.min.js';

const BRAINTREE_LOADING_TIME_MS = 2000;

const TICKETING_MAIN_TEXT_COLOR_VARNAME = 'ticketing-mainTextColor';

const BraintreeLogo = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 100" {...props}>
		<path d="M251.807 10.67v15.612h12.043V10.67h-12.043zm120.01 7.137v18.22h-13.06V46.24h13.06v20.945c0 12.738 8.461 20.75 22.228 20.75 7.74 0 15.357-2.846 21.564-9.711l-7.046-7.234c-3.694 4.028-8.301 6.894-14.561 6.894-6.747 0-11.512-3.343-11.512-10.598V46.213h24.428V36.028H382.49V17.807h-10.674zm-339.174.135v10.111h7.892v48.176h-7.892v9.949H65.75c20.25 0 25.568-10.452 25.72-18.672.157-8.441-4.783-13.944-13.702-16.596 6.321-2.603 10.005-7.84 10.005-14.78 0-11.402-9.626-18.188-21.925-18.188H32.643zm18.888 10.14h12.131c9.884 0 13.055 4.602 13.055 9.21 0 4.347-2.896 9.208-13.055 9.208h-12.13V28.082zm464.813 6.178c-15.907 0-27.797 11.205-27.797 26.625 0 17.007 13.03 27.104 28.625 27.104 9.753 0 20.394-3.92 25.062-9.579l-7.078-7.406c-3.163 3.314-8.716 6.973-17.398 6.973-13.88 0-17.844-10.532-17.844-13.16h43.242c.973-16.47-10.315-30.557-26.812-30.557zm64.625 0c-15.907 0-27.797 11.205-27.797 26.625 0 17.007 13.03 27.104 28.625 27.104 9.753 0 20.394-3.92 25.062-9.579l-7.078-7.406c-3.163 3.314-8.716 6.973-17.398 6.973-13.88 0-17.844-10.532-17.844-13.16h43.242c.973-16.47-10.315-30.557-26.812-30.557zm-250.25.01c-6.156 0-12.804 1.985-17.063 7.736v-6.068h-17.693v10.324h7.11v29.73h-7.678V86.2h26.36V75.993h-7.958V58.926c0-7.54 7.02-14.312 15.703-14.312 6.806 0 9.963 4.362 9.963 11.322v20.057h-8.018V86.2h26.34V75.993h-7.66V53.598c0-14.574-10.645-19.328-19.406-19.328zm-141.22.022c-7.45.17-15.254 2.957-21.03 8.54l7.025 7.514c8.919-8.66 26.375-8.81 26.375 4.297v2.098s-7.9-1.932-13.115-1.932c-13.477 0-23.535 6.464-23.535 17.29 0 7.363 5.297 15.796 19.453 15.796 12.95 0 17.207-6.746 17.207-6.746v5.1h18.2V76.036h-7.298V53.473c0-12.286-10.275-18.903-21.799-19.181a31.662 31.662 0 0 0-1.484 0zm-48.74.068c-7.127.14-14.332 3.629-17.59 9.824v-8.21h-19.192v10.288h8.61V76.04h-11.073v10.17h39.244V76.04h-17.522V62.852c0-19.29 23.564-23.746 25.596-12.1l9.996-3.044c-2.013-9.368-9.99-13.508-18.068-13.348zm323.313 0c-7.127.14-14.333 3.629-17.59 9.824v-8.21H427.29v10.288h8.611V76.04h-11.074v10.17h39.246V76.04H446.55V62.852c0-19.29 23.563-23.746 25.596-12.1l9.996-3.044c-2.013-9.368-9.99-13.508-18.069-13.348zm-227.04 1.473V46.28h16.03v29.685h-20.974v10.332h51.094V75.965h-19.309V35.833h-26.842zm279.132 8.125c9.6 0 14.804 8.749 14.697 11.824h-30.418c.597-4.21 5.965-11.824 15.721-11.824zm64.625 0c9.6 0 14.804 8.749 14.697 11.824h-30.418c.597-4.21 5.965-11.824 15.721-11.824zM51.531 56.27h14.29c10.126 0 14.644 4.64 14.644 9.822 0 5.166-3.558 10.016-14.645 10.016H51.531V56.27zm137.553 7.6c6.12 0 12.906 2.142 12.906 2.142.508 5.303-4.422 12.33-16.396 12.33-3.71 0-9.381-1.37-9.303-6.363.083-5.285 5.012-8.11 12.793-8.11z" />
	</svg>
);

const loadScript = src => new Promise((resolve) => {
	const script = document.createElement('script');
	script.addEventListener('load', () => { resolve(); });
	script.src = src;
	document.body.appendChild(script);
});

const loadScriptIf = (src, condition, name) => new Promise((resolve, reject) => {
	if (!condition()) {
		loadScript(src).then(() => {
			if (condition()) {
				resolve();
			} else {
				reject(`the ${name} script could not be loaded correctly`);
			}
		}, () => {
			reject(`could not load ${name} script`);
		});
	} else {
		resolve();
	}
});

const checkSdk = () => !!window.braintree;
const checkHF = () => window.braintree && window.braintree.hostedFields;
const check3DS = () => window.braintree && window.braintree.threeDSecure;

export default class BraintreePaymentGateway extends Component {

	constructor(props) {
		super(props);

		const stylingVars = accessNested(props.appData, 'styling.variables', {});
		this.textColor = stylingVars[TICKETING_MAIN_TEXT_COLOR_VARNAME] || '#000';

		this.state = {
			loading: true,
			loadingText: ''
		};

		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.processResponse = this.processResponse.bind(this);
	}

	componentDidMount() {
		this.loadSdk();
	}

	loadSdk() {
		const that = this;
		loadScriptIf(BRAINTREE_SDK_SRC, checkSdk, 'Braintree SDK').then(() => {
			const hfProm = loadScriptIf(BRAINTREE_HOSTED_FIELDS_SRC, checkHF, 'Braintree HostedFields');
			const tdsProm = loadScriptIf(BRAINTREE_THREE_D_SECURE_SRC, check3DS, 'Braintree 3-D Secure');
			Promise.all([hfProm, tdsProm]).then(() => {
				that.setupSdk();
			}, (err) => {
				console.error(`BraintreePaymentGateway:loadSdk(): ${err}`);
			});
		}, (err) => {
			console.error(`BraintreePaymentGateway:loadSdk(): ${err}`);
		});
	}

	setupSdk() {
		if (!checkSdk() || !checkHF() || !check3DS()) {
			console.error('BraintreePaymentGateway:setupSdk(): Braintree libraries are not loaded in');
			return;
		}

		const that = this;

		window.braintree.client.create({
			authorization: this.props.ticketing.paymentData.token
		}, (clientErr, clientInstance) => {
			if (clientErr) {
				// TODO: Go to error
				console.error(`BraintreePaymentGateway:setupSdk(): ${clientErr}`);
				return;
			}
			window.braintree.hostedFields.create({
				client: clientInstance,
				styles: {
					'input': {
						'padding': '0.4rem 0.2rem',
						'color': this.textColor,
						'font-size': '1rem',
						'outline': 'none'
					}
				},
				fields: {
					number: {
						selector: '#braintree-card-number',
						placeholder: generateCardNumPlaceholder()
					},
					expirationDate: {
						selector: '#braintree-expiration-date',
						placeholder: '01/2020' // TODO: dynamic placeholder date
					},
					cvv: {
						selector: '#braintree-cvv',
						placeholder: '123'
					},
					postalCode: {
						selector: '#braintree-postal-code',
						placeholder: '92234'
					}
				}
			}, (hostedFieldsErr, hostedFieldsInstance) => {
				if (hostedFieldsErr) {
					// TODO: Go to error
					console.error(`BraintreePaymentGateway:setupSdk(): ${hostedFieldsErr}`);
					return;
				}
				that.hostedFieldsInstance = hostedFieldsInstance;
				window.braintree.threeDSecure.create({
					client: clientInstance,
					version: 2
				}, (threeDSecureErr, threeDSecureInstance) => {
					if (threeDSecureErr) {
						// TODO: Go to error
						console.error(`BraintreePaymentGateway:setupSdk(): ${threeDSecureErr}`);
						return;
					}
					that.threeDSecureInstance = threeDSecureInstance;
				});
			});

			setTimeout(() => that.setState({ loading: false }), BRAINTREE_LOADING_TIME_MS);
		});
	}

	onFormSubmit(event) {
		event.preventDefault();
		if (!this.hostedFieldsInstance) {
			console.error('BraintreePaymentGateway:onFormSubmit(): no hostedFields instance');
			return;
		}
		if (!this.threeDSecureInstance) {
			console.error('BraintreePaymentGateway:onFormSubmit(): no threeDSecure instance');
			return;
		}

		this.setState({
			loading: true,
			loadingText: 'Processing payment...'
		});

		const that = this;
		this.hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
			if (tokenizeErr) {
				if (isObject(tokenizeErr)) {
					// TODO: Localize error
					Store.emit(actions.SET_TICKETING_MESSAGE, { message: tokenizeErr.message });
				}
				that.setState({ loading: false });
			} else {
				that.processResponse(payload);
			}
		});
	}

	processResponse(payload) {
		if (!isObject(payload) || !payload.nonce) {
			Store.emit(actions.SET_TICKETING_MESSAGE, { message: 'Incorrect response from gateway' });
			this.setState({ loading: false });
		} else {
			const that = this;

			const amount = this.props.ticketing.order.price.toString();

			const verifyCardParams = {
				amount,
				nonce: payload.nonce,
				onLookupComplete: (data, next) => {
					next();
				}
			};

			if (isObject(payload.details) && typeof payload.details.bin === 'string') {
				verifyCardParams.bin = payload.details.bin;
			}

			this.threeDSecureInstance.verifyCard(verifyCardParams, (err, response) => {
				if (err || response.liabilityShiftPossible && !response.liabilityShifted) {
					if (err) {
						console.log('processResponse(): Error from Braintree:', err);
					}
					Store.emit(actions.SET_TICKETING_MESSAGE, { message: '3-D Secure verification failed, please try again with another card' });
					that.setState({ loading: false });
					return;
				}
				Store.emit(actions.PAYMENT_MESSAGE_RECEIVED, { payload: response });
			});
		}
	}

	render(props, { loading, loadingText }) {
		const {
			ticketing, // Object - the ticketing state
			theater,   // Object - the active theater
			currencyCopy = 'CURRENCY'
			// client     // Object - the client information object
		} = props;

		const theaterName = accessNested(ticketing, 'meta.theaterName');

		return (
			<form onSubmit={this.onFormSubmit} class={joinClasses(s.container, props.class)}>
				{loading && (
					<PaymentLoader text={loadingText} bgColor="transparent" color={this.textColor} textColor={this.textColor}>
						<BraintreeLogo />
					</PaymentLoader>
				)}
				<div class={s.formWrapper} style={displayWhen(!loading)}>
					<h1 class={s.header}>{getCopy('WHAT_PAYMENT_DETAILS')}</h1>
					<p class={s.instructions}>{getCopy('PROVIDE_PAYMENT_INFO', { THEATER_NAME: theaterName })}</p>
					<div class={s.cardNumberBlock}>
						<label for="braintree-card-number">Card Number</label>
						<div class={s.braintreeHostedField} id="braintree-card-number" />
					</div>
					<div class={s.expirationDateBlock}>
						<label for="braintree-expiration-date">Expiration Date</label>
						<div class={s.braintreeHostedField} id="braintree-expiration-date" />
					</div>
					<div class={s.cvvBlock}>
						<label for="braintree-cvv">CVV</label>
						<div class={s.braintreeHostedField} id="braintree-cvv" />
					</div>
					<div class={s.postalCodeBlock}>
						<label for="braintree-postal-code">Postal Code</label>
						<div class={s.braintreeHostedField} id="braintree-postal-code" />
					</div>
					<footer class={s.footer}>
						<p>
							<svg class={s.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
								<path d="M50.164 13.896c-12.817 0-23.292 10.446-23.342 23.252v6.956h-1.029a4.283 4.283 0 0 0-4.293 4.294v33.414a4.283 4.283 0 0 0 4.293 4.292h48.414a4.283 4.283 0 0 0 4.293-4.292V48.398a4.283 4.283 0 0 0-4.293-4.294h-.703v-6.956c-.05-12.806-10.523-23.252-23.34-23.252zm0 7.5c8.763 0 15.789 7 15.838 15.752v6.956H34.324v-6.956a15.785 15.785 0 0 1 15.84-15.752zM50 54.426a6.045 6.045 0 0 1 6.045 6.046 6.045 6.045 0 0 1-3.945 5.664l.9 7.152h-6l.9-7.154a6.045 6.045 0 0 1-3.945-5.662A6.045 6.045 0 0 1 50 54.427z" />
							</svg>
							<span class={s.encryption}>SSL Encryption</span>
							<span>powered by</span>
							<Link class={s.braintreeLogo} target="_blank" href="https://www.braintreepayments.com/" renderCustomChild>
								<BraintreeLogo />
							</Link>
						</p>
					</footer>
				</div>
				<div class={bb.wrapper}>
					<div class={bb.info}>
						<div class={bb.total}>
							{getCopy('TOTAL', {}, 'Total')}
							<span class={bb.totalAmount}>{getCopy(currencyCopy, { value: getOrderTotalPrice(ticketing) })}</span>
						</div>
					</div>
					<div class={bb.buttonWrapper}>
						<button class={bb.button} onClick={this.onFormSubmit} disabled={loading} style={{ maxWidth: '155px' }}>Pay</button>
					</div>
				</div>
			</form>
		);
	}

}
